/**
 * Marca do AxiomGO do topo (a mesma do Sidebar): viewBox 64, traço 2.5,
 * `currentColor`. Fonte única do path — Sidebar e CarregandoAxiom importam
 * daqui, ninguém copia o desenho.
 */
import type { SVGProps } from 'react'

interface AxiomLogoTopoProps extends SVGProps<SVGSVGElement> {
  /** Lado em px (largura = altura). */
  size?: number
}

export function AxiomLogoTopo({ size = 28, ...props }: AxiomLogoTopoProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g
        transform="translate(32,32)"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      >
        <path d="M-2,-22 L-2,-18 A18,18 0 0,0 -15.6,9 L-19,11 L-17,15 L-13,13 A18,18 0 0,0 -2,18 L-2,22" />
        <path d="M-2,-18 A18,18 0 0,0 -2,18" />
        <line x1="-4" y1="-22" x2="2" y2="-22" />
        <line x1="-21" y1="10" x2="-18" y2="14" />
        <line x1="-4" y1="22" x2="2" y2="22" />
        <path d="M-2,-10 A10,10 0 0,0 -2,10" />
        <line x1="4" y1="0" x2="20" y2="0" />
        <line x1="4" y1="-8" x2="14" y2="-8" />
        <line x1="14" y1="-8" x2="14" y2="-14" />
        <line x1="4" y1="8" x2="14" y2="8" />
        <line x1="14" y1="8" x2="14" y2="14" />
        <circle cx="20" cy="0" r="2" fill="currentColor" />
        <circle cx="14" cy="-14" r="2" fill="currentColor" />
        <circle cx="14" cy="14" r="2" fill="currentColor" />
      </g>
    </svg>
  )
}
